<template>
    <w-btn
        v-if="show"
        :color="error ? 'red' : 'blue'"
        :loading="loading"
        :disabled="disabled"
        :text="$t('common.next')"
        :icon="error ? 'mdi-alert' : 'mdi-page-next'"
        @press="press"
    />
</template>

<script>
export default {
    name: 'WBtnNext',
    props: {
        show: Boolean,
        loading: Boolean,
        disabled: Boolean,
        error: Boolean,
    },
    emits: ['press'],
    setup(props, {emit}) {
        function press() {
            emit('press');
        }

        return {
            press,
        }
    }
}
</script>

<style scoped>

</style>